import { compose } from "redux";
import { withProps, branch } from "../wecompose";
import ErrorPage from "../../routes/ErrorPage";

const withFatalErrorWhen =
  (conditionFunc, code, messageFunc = () => null, dataFunc = () => {}) =>
  (Component) => {
    const ErrorBranch = compose(
      withProps((props) => {
        const errorStatus = conditionFunc(props) ? code : null;
        let errorMessage = null;
        let errorData = {};

        if (errorStatus) {
          errorMessage = messageFunc ? messageFunc(props) : errorMessage;
          errorData = dataFunc ? dataFunc(props) : errorData;
        }
        return { errorStatus, errorMessage, errorData };
      }),
      branch(
        ({ errorStatus }) => !!errorStatus,
        () => ErrorPage
      )
    )(Component);

    ErrorBranch.displayName = Component.displayName;
    ErrorBranch.fragment = Component.fragment;

    return ErrorBranch;
  };

export default withFatalErrorWhen;

// with500ErrorWhen returning error message as well as status code for temporary testing.
export const with500ErrorWhen = (conditionFunc, messageFunc) =>
  withFatalErrorWhen(conditionFunc, 500, messageFunc);
export const with404ErrorWhen = (conditionFunc, messageFunc, dataFunc) =>
  withFatalErrorWhen(conditionFunc, 404, messageFunc, dataFunc);

export const with410ErrorWhen = (conditionFunc) =>
  withFatalErrorWhen(conditionFunc, 410);
